export class ErrorResponse extends Error {
  code: number;
  errorId: string;
  email?: string;
  providerName?: string;
  providerLogo?: string;
  constructor(msg: string, code: number, errorId: string) {
    super(msg);
    this.code = code;
    this.errorId = errorId;

    Object.setPrototypeOf(this, ErrorResponse.prototype);
  }
  getCode() {
    return this.code;
  }
  getEmail() {
    return this.code;
  }
  getErrorId() {
    return this.errorId;
  }
}

export enum ErrorType {
  Unexpected = 100,
  AnotherAccountGlobo = 101,
  ErrProviderWithoutResources = 102,
  UserWithoutPackage = 103,
  InvalidCredentials = 104,
  ErrCommunicationWithProvider = 105,
  ProviderGenericError = 106
}
